export default __webpack_public_path__ + "static/media/Angsana_Logo.026ff119.png";